import React from 'react';
import styled from 'styled-components';
import FA from './FontAwesome';

type Props = {
  displayStyle?: 'text' | 'symbol';
};

const RequiredText = styled.span`
  color: red;
  font-weight: 700;
  font-size: 0.7rem;
`;

const RequiredIcon = styled(FA)`
  color: red;
  font-size: 6px;
  position: absolute;
  top: 3px;
  right: 0;
  line-height: 1;
`;

const IconWrapper = styled.span`
  position: relative;
  height: 1em;
  width: 6px;
  display: inline-block;
`;

const Required = ({ displayStyle = 'symbol' }: Props) =>
  displayStyle === 'text' ? (
    <RequiredText>(必須)</RequiredText>
  ) : (
    <IconWrapper>
      <RequiredIcon icon="asterisk" />
    </IconWrapper>
  );

export default Required;
